import { styled } from 'stitches.config'
import { HeaderRoot } from 'components/Header/Header.styles'

export const AllProductsHeaderRoot = styled('div', {
  width: '100%',
  position: 'sticky',
  top: '0',
  zIndex: '$1',

  variants: {
    isScrollingDown: {
      true: {
        [`& ${HeaderRoot}`]: {
          display: 'none',

          '@bp2': {
            display: 'block',
          },
        },
      },
    },
  },
})
